import { signal } from '@preact/signals-react';

// Aviso de nova versão do PWA (modo prompt). Dedicado — NÃO reusar `alertaMensagem`,
// que é compartilhado pelos alertas de erro. `registration` guarda o ServiceWorkerRegistration
// cujo `waiting` será promovido ao clicar "Atualizar". `versao`/`novidades` (T2) enriquecem a
// mensagem com o conteúdo do changelog.json; ficam null quando o fetch falha (fallback genérico).
export const atualizacaoDisponivel = signal({
    open: false,
    registration: null,
    versao: null,
    novidades: null,
});
